

















import store from '@/store';
import Global from '@/common/global.js'

export default
  name: 'TextBox'

  props:
    # value
    value:
      type: String
      default: null
    # Props名
    name:
      type: String
      default: ''
    # maxlength
    maxlength:
      type: Number
      default: 200
    # placeholder
    placeholder:
      type: String
      default: ''
    # タイプ
    type:
      type: String
      default: 'text'
    # リードオンリー
    readonly:
      type: Boolean
      default: false
    # GROUP
    group:
      type: String
      default: null
    # コントロール配列
    index:
      type: Number
      default: null
    # APIからの返却値(エラー表示)
    apiData:
      type: Object
    noRightRadius:
      type: Boolean
      default: false
    paddingSmall:
      type: Boolean
      default: false
    noStore:
      type: Boolean
      default: false
    color_white:
      type: Boolean
      default: false
    height42:
      type: Boolean
      default: false

  watch: {
    value: (v) ->
      @v = v
      @_saveStore(v)
  }

  data: () ->
    v: @value

  mounted: () ->
    if (!Global.hasGroupIndexValue(@group, @index, @name))
      @_saveStore('')

  computed: {
    val: () ->
      return @v

    isDetailChange: () ->
      if !@noStore
        @v = Global.getGroupIndexValue(@group, @index, @name)
        return store.getters.isSetDetail
      return ''
  }

  methods: {
    change: (e) ->
      e.target.value = e.target.value.slice(0, 4)
      @_saveStore(e.target.value)
      @$emit('change', {val: e.target.value, name: @name, index: @index})
    click: (e) ->
      @$emit('click')
    keydown: (e) ->
      # if @type == 'number'
      #   if e.keyCode == 38 || e.keyCode == 40
      #     e.stopImmediatePropagation()
      #     e.preventDefault()
      #   else if !Global.checkKeyCode(e)
      #     if e.target.value.length >= @maxlength
      #       e.stopImmediatePropagation()
      #       e.preventDefault()
    _saveStore: (value) ->
      if !@noStore
        store.dispatch('setPostParam', {label: @name, value: value, index: @index, group: @group})
  }
